import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import { MonthPickerComponent } from '../monthpicker/month-picker';
import { YearPickerComponent } from '../monthpicker/YearPicker';
import { YearPickerComponent1 } from '../monthpicker/YearPicker1';
@Directive({
    selector: '[monthpicker]'
})
export class MonthPickerDirective implements OnInit {

    constructor(
        private elementRef: ElementRef,
        private monthpicker: MonthPickerComponent,
        private yearpicker: YearPickerComponent,
        private yearpicker1: YearPickerComponent1
    ) {

    }
    ngOnInit() {
        this.monthpicker.ngOnInit();
    }


}


// WEBPACK FOOTER //
// ./src/app/directive/monthPicker.directive.ts